import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

const navItems = [
  { id: 'dashboard', path: '/', icon: '📊', label: 'Dashboard' },
  { id: 'projects', path: '/projects', icon: '🏗️', label: 'Proyek' },
  { id: 'reports', path: '/reports', icon: '📋', label: 'Laporan Harian' },
  { id: 'rab', path: '/rab', icon: '💰', label: 'RAB & AHS' },
  { id: 'materials', path: '/materials', icon: '📦', label: 'Material' },
  { id: 'workers', path: '/workers', icon: '👷', label: 'Tenaga Kerja' },
  { id: 'invoices', path: '/invoices', icon: '💳', label: 'Invoice' },
  { id: 'documents', path: '/documents', icon: '📸', label: 'Dokumen' },
]

export default function Sidebar({ sbOpen, setSbOpen }) {
  const navigate = useNavigate()
  const location = useLocation()
  const { profile, signOut } = useAuth()

  const currentPath = location.pathname
  const currentPage = currentPath === '/' ? 'dashboard' : currentPath.replace('/', '')

  const handleNav = (path) => {
    navigate(path)
    setSbOpen(false)
  }

  return (
    <>
      {/* Overlay for mobile */}
      <div className={`sidebar-overlay${sbOpen ? ' show' : ''}`} onClick={() => setSbOpen(false)} />

      <div className={`sidebar${sbOpen ? ' open' : ''}`}>
        {/* Header / Brand */}
        <div className="sidebar-header">
          <img src="/logo.png" alt="Undagi Logo" style={{ width: 36, height: 36, objectFit: 'contain', flexShrink: 0 }} />
          <div className="sidebar-brand">
            <h1>Undagi</h1>
            <p>Project Management</p>
          </div>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <div
              key={item.id}
              className={`nav-item${currentPage === item.id ? ' active' : ''}`}
              onClick={() => handleNav(item.path)}
            >
              <span style={{ fontSize: 16 }}>{item.icon}</span>
              <span>{item.label}</span>
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {profile?.full_name || profile?.email || 'Pengguna'}
          </div>
          <button
            className="btn btn-secondary btn-sm"
            style={{ width: '100%' }}
            onClick={async () => { await signOut(); navigate('/login') }}
          >
            🚪 Keluar
          </button>
        </div>
      </div>
    </>
  )
}